import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  fillRule: "evenodd",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M1.5 7.485a3 3 0 0 1 3-3h15a3 3 0 0 1 3 3v10.5a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3zm3-1.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-10.5a1.5 1.5 0 0 0-1.5-1.5zm9.25 3.75a.75.75 0 0 1 .75-.75H19a.75.75 0 1 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75H19a.75.75 0 1 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75H19a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m-1.891-5.55a.75.75 0 0 1 .042 1.06l-4.312 4.667a.75.75 0 0 1-1.102 0L4.8 14.086a.75.75 0 0 1 1.102-1.018l1.137 1.23 3.762-4.071a.75.75 0 0 1 1.06-.042z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const ChecklistIcon = ForwardRef;